import {hideNewBadgePopup} from '@/state/slices/modalSlice';
import {dispatch} from '@/state/store';
import {NewBadgePopupTemplate} from '@/views/Loyalty/PopupTemplates';

import LoyaltyModalPopup from './LoyaltyModalPopup';

const NewBadgePopup = () => {
    const handleClose = () => {
        dispatch(hideNewBadgePopup());
    };

    return (
        <LoyaltyModalPopup>
            <NewBadgePopupTemplate onClose={handleClose} onGotIt={handleClose} isChipVisible isDescriptionVisible />
        </LoyaltyModalPopup>
    );
};

export default NewBadgePopup;
